import React from 'react';

export const NavigationIconButton: React.CSSProperties = {
  position: 'absolute',
  top: '50%',
  transform: 'translateY(-50%)',
  zIndex: 15,
  width: '40px',
  height: '40px',
  backgroundColor: '#fff',
  borderRadius: '50%',
  padding: 0,
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  border: 'none',
  cursor: 'pointer',
  flexShrink: 0,
  transition: 'background-color 150ms ease',
  WebkitTapHighlightColor: 'transparent',
};

export const NavigationIconButtonLeft: React.CSSProperties = {
  left: 0,
  boxShadow: '4px 6px 12px rgba(0,0,0,0.2)',
};

export const NavigationIconButtonRight: React.CSSProperties = {
  right: 1,
  boxShadow: '-4px 6px 12px rgba(0,0,0,0.2)',
};

export const NavigationIconButtonHover: React.CSSProperties = {
  backgroundColor: '#f5f5f5',
};
